import router from './router';
// import NProgress from "nprogress"; // Progress 进度条
// import "nprogress/nprogress.css"; // Progress 进度条样式
import { ElMessage } from 'element-plus';
import { useLocalStorage } from '@vueuse/core';
import tool from '@/common/tool';
import { platformApi } from '@/request/api/platform';
import request from '@/request/request.js';
import menuList from './common/menuList';
import menuListId from './common/menuListId';
import { addMenu, filterAsyncRoutes } from './addMenu';
import fxsMenuList from '@/common/fxs-menuList';

const whiteList = [
  '/login',
  '/register',
  '/authorization',
  '/404',
  '/403',
  '/manage#/downloadMonthReport',
  '/manage/#/downloadMonthReport',
];
// 检查是否为弱密码
const checkWeakPassword = () => {
  return tool.getLocalStorage('IsWeakPassword') || false;
};
const RouterList = useLocalStorage('RouterList');
const menuIdData = useLocalStorage('menuIdData');
let isShowPage = [];
let init = false;

// router.afterEach((to, from) => {
//   NProgress.done(); // 结束Progress
// });

const dealHashPath = (to) => {
  // 去除？
  let url = to.hash.split('?')[0] || '';

  //  #/organizationManage 这边特殊处理 暂时写死 因为没用?传值无法判断路由
  if (url.indexOf('#/organizationManage') > -1) {
    url = '#/organizationManage/0';
  }

  return `/${to.name}/${url}`;
};

const promiseAllRequest = () => {
  const promise1 = request({
    apiModule: platformApi.listUserMenu,
  });
  return Promise.all([promise1]);
};

const gotoRouter = async (to, next) => {
  try {
    let [res] = await promiseAllRequest();
    if (tool.checkRequestResult(res)) {
      // 这边更改的数据结构，先写死测试
      // res.data = [
      //   {
      //     menuId: 1,
      //     menuName: '首页',
      //     childMenus: null,
      //   },
      //   {
      //     menuId: 2,
      //     menuName: '差旅预订',
      //     childMenus: [],
      //   },
      //   {
      //     menuId: 4,
      //     menuName: '架构管理',
      //     childMenus: [
      //       {
      //         menuId: 3,
      //         menuName: '组织管理',
      //         childMenus: [
      //           {
      //             menuId: 19,
      //             menuName: '组织架构',
      //             childMenus: null,
      //           },
      //         ],
      //       },
      //       {
      //         menuId: 20,
      //         menuName: '流程管理',
      //         childMenus: null,
      //       },
      //       {
      //         menuId: 32,
      //         menuName: '子母公司',
      //         childMenus: [
      //           {
      //             menuId: 67,
      //             menuName: '集团架构',
      //             childMenus: null,
      //           },
      //           {
      //             menuId: 66,
      //             menuName: '开票设置',
      //             childMenus: null,
      //           },
      //         ],
      //       },
      //       {
      //         menuId: 5,
      //         menuName: '权限管理',
      //         childMenus: [
      //           {
      //             menuId: 89,
      //             menuName: '功能权限',
      //             childMenus: null,
      //           },
      //           {
      //             menuId: 88,
      //             menuName: '数据权限',
      //             childMenus: null,
      //           },
      //         ],
      //       },
      //     ],
      //   },
      //   {
      //     menuId: 33,
      //     menuName: '差旅管控',
      //     childMenus: [
      //       {
      //         menuId: 96,
      //         menuName: 'yinsi'
      //       }
      //     ]
      //   }
      // ];
      // 测试结束
      const resData = JSON.parse(JSON.stringify(res.data));
      // tool.setLocalStorage('_Customer_Name_', resData.userName);
      menuIdData.value = JSON.stringify(resData || []);
      const localMenuList = filterAsyncRoutes(menuList, flatTreeIds(resData));

      RouterList.value = JSON.stringify(localMenuList || []);

      isShowPage = addIsShowPage(resData);
      init = true;

      addmenuListNew();

      if (to.path == '/') {
        next('/TravelBooking');
      } else {
        next({ ...to, replace: true });
      }
    } else {
      ElMessage.error(res.message);
      localStorage.clear();
      window.location.href = window.location.protocol + '//' + window.location.host + '/login';
    }
  } catch (error) {
    ElMessage.error(error.message);
  }
};

const loadFxsRouter = async (to, next) => {
  try {
    const customerInfo = tool.getLocalStorage('_User_Info_');
    const showMenu = customerInfo['IsManager'] ? fxsMenuList : [{ menuId: 2 }];
    const localMenuList = addMenu(fxsMenuList, showMenu);
    RouterList.value = JSON.stringify(localMenuList);
    init = true;
    if (to.path == '/') {
      next('/fxxt/TravelBooking');
    } else {
      next({ ...to, replace: true });
    }
  } catch (error) {
    ElMessage.error(error.message);
  }
};

const addIsShowPage = (data) => {
  let arr = flatTreeIds(data);
  return menuListId.filter((i) => arr.includes(i.menuId)).map((i) => i.url);
};

// 树结构id扁平化
function flatTreeIds(data, childrenKey = 'childMenus') {
  return data.reduce((acc, cur) => {
    acc.push(cur.menuId);
    if (cur[childrenKey] && cur[childrenKey].length) {
      acc = acc.concat(flatTreeIds(cur[childrenKey], childrenKey));
    }
    return acc;
  }, []);
}

const addmenuListNew = async () => {
  let res = await request({
    apiModule: platformApi.listUserMenuNew,
  });
  if (tool.checkRequestResult(res)) {
    let datas = res.data || [];

    let result = {
      name: '数据魔方',
      type: 'module',
      icon: '',
      url: '',
      menus: [],
      hidden: false,
    };
    let list = setMenuList(datas, 0, []);
    result.menus = list;

    RouterList.value = JSON.stringify(JSON.parse(RouterList.value).concat(result));
  }
};

const setMenuList = (rootList, id, list) => {
  rootList.forEach((item) => {
    if (item.parentId == id) {
      list.push(setMenuItem(item));
    }
  });

  list.forEach((i) => {
    i.menus = [];
    setMenuList(rootList, i.menuId, i.menus);
  });

  return list;
};

const setMenuItem = (item) => {
  let mItem = {
    hidden: false,
    icon: item.icon,
    name: item.menuName,
    url: item.pageLink || item.menuName,
    type: 'menu',
    routerType: 'iframe',
    pId: item.parentId,
    menuId: item.id,
  };

  return mItem;
};

// 判断是不是第一次进应用
let firstLoaded = true;

export const permissionHandle = async (to, from, next) => {
  let MemberId = (tool.getLocalStorage('_User_Info_') || {}).MemberId || '';
  let Token = (tool.getLocalStorage('_User_Info_') || {}).Token || '';
  let platId = tool.getLocalStorage('PlatId') || '';

  // 检查弱密码：如果是弱密码且不在登录/授权页，强制跳转到登录页
  const isWeakPassword = checkWeakPassword();
  if (isWeakPassword && to.path !== '/login' && to.path !== '/authorization' && Token && MemberId) {
    ElMessage.warning('您的密码过于简单,有泄露风险,请重新登录修改密码。');
    next('/login');
    return;
  }

  if (platId == '1005') {
    if (Token && MemberId) {
      if (to.path.includes('404')) {
        next('/fxxt/index');
      }
      if (to.path !== '/login') {
        tool.setLocalStorage('showBreadcrumb', false);
        if (init) {
          next();
        } else {
          // 加载分销商后台菜单
          loadFxsRouter(to, next);
        }
      } else {
        next('/');
      }
    } else {
      if (to.path !== '/login') {
        next('/login');
      } else {
        next();
      }
    }
    return;
  }

  // NProgress.start();
  let routerPath = '';
  if (to.hash) {
    routerPath = dealHashPath(to);
  } else {
    routerPath = to.path;
  }
  if (whiteList.indexOf(routerPath) !== -1) {
    next();
  } else {
    if (Token && MemberId) {
      if (to.path !== '/login') {
        tool.setLocalStorage('showBreadcrumb', false);
        if (init) {
          // 根据hash判断是否是跳转微应用
          if (isShowPage.indexOf(routerPath) > -1) {
            next();
          } else {
            next();
          }
        } else {
          gotoRouter(to, next);
        }
      } else {
        // 如果已登录且访问登录页，检查是否有弱密码标识
        // 如果没有弱密码问题，跳转到首页
        if (!isWeakPassword) {
          next('/');
        } else {
          // 有弱密码问题，允许访问登录页进行密码修改
          next();
        }
      }
    } else {
      if (to.path !== '/login') {
        next('/login');
      } else {
        next();
      }
    }
  }
};
